// extracted by mini-css-extract-plugin
export default {"backdrop":"BackDrop_backdrop__sy4z5","dbackdrop":"BackDrop_dbackdrop__9NZbL"};